import { useEffect, useState } from 'react';
import axios from 'axios';
import { Download, FileText, Loader2, Mail, User } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { API, StarScore } from './stars';

const dt = (s) => (s ? new Date(s).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '-');

// Talebin denetim geçmişi: kim, ne zaman, kaç kez, puan, not + gönderilen PDF önizleme/indirme
export const AuditHistoryDialog = ({ permit, onClose }) => {
  const [audits, setAudits] = useState(null);
  const [sel, setSel] = useState(null);
  const [pdf, setPdf] = useState(null);
  useEffect(() => {
    if (!permit) return;
    setAudits(null); setSel(null);
    axios.get(permit.url || `${API}/five-star/permits/${permit.id}/audits`).then(r => { setAudits(r.data); setSel(r.data[0] || null); }).catch(() => setAudits([]));
  }, [permit]);
  useEffect(() => {
    if (!sel) { setPdf(null); return; }
    setPdf('loading');
    axios.get(`${API}/five-star/audits/${sel.id}/pdf`, { responseType: 'blob' }).then(r => setPdf(URL.createObjectURL(r.data))).catch(() => setPdf(null));
  }, [sel]);
  const download = () => { const a = document.createElement('a'); a.href = pdf; a.download = `five_star_${sel.request_number || permit.request_number}_${sel.created_at.slice(0, 10)}.pdf`; a.click(); };
  return (
    <Dialog open={!!permit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-6xl overflow-hidden" data-testid="audit-history-dialog">
        <DialogHeader><DialogTitle>Denetim Geçmişi · <span className="font-mono">{permit?.request_number}</span> · {permit?.company_name} {audits && <span className="text-sm font-normal text-slate-500">({audits.length} denetim)</span>}</DialogTitle></DialogHeader>
        {audits === null ? <Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" /> : audits.length === 0 ? <p className="py-10 text-center text-sm text-slate-500">Bu talep henüz denetlenmedi</p> : (
          <div className="grid h-[72vh] gap-4 md:grid-cols-[320px_1fr]">
            <div className="space-y-2 overflow-y-auto pr-1">
              {audits.map((a, i) => (
                <button key={a.id} type="button" onClick={() => setSel(a)} className={`w-full rounded-lg border p-3 text-left text-sm transition-colors ${sel?.id === a.id ? 'border-amber-400 bg-amber-50' : 'hover:bg-slate-50'}`} data-testid={`audit-history-item-${a.id}`}>
                  <div className="flex items-center justify-between"><b>{audits.length - i}. denetim{a.request_number && permit.url ? <span className="ml-1 font-mono text-xs font-normal text-slate-500">{a.request_number}</span> : null}</b><StarScore value={a.score} /></div>
                  <p className="mt-1 flex items-center gap-1 text-xs text-slate-600"><User className="h-3 w-3" />{a.auditor_name} · {dt(a.created_at)}</p>
                  {a.isg_note && <p className="mt-1 line-clamp-3 text-xs text-amber-800">{a.isg_note}</p>}
                  <p className="mt-1 flex items-center gap-1 text-[11px] text-slate-500"><Mail className="h-3 w-3" />{a.sent_at ? `Firmaya gönderildi: ${(a.sent_to || []).join(', ')} · ${dt(a.sent_at)}` : 'E-posta gönderilmedi'}</p>
                </button>
              ))}
            </div>
            <div className="flex flex-col overflow-hidden rounded-lg border bg-slate-100">
              <div className="flex items-center justify-between border-b bg-white px-3 py-2 text-sm">
                <span className="flex items-center gap-1 text-slate-600"><FileText className="h-4 w-4" />Firmaya gönderilen PDF</span>
                <Button size="sm" variant="outline" disabled={!pdf || pdf === 'loading'} onClick={download} data-testid="audit-history-download"><Download className="mr-1 h-4 w-4" />PDF İndir</Button>
              </div>
              {pdf === 'loading' ? <Loader2 className="m-auto h-6 w-6 animate-spin text-slate-400" /> : pdf ? <iframe title="PDF önizleme" src={pdf} className="h-full w-full" data-testid="audit-history-pdf" /> : <p className="m-auto text-sm text-slate-500">PDF yüklenemedi</p>}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
